<template>
  <aside class="sidebar-desktop">
    <div class="sidebarWrap" :class="{ active: modelValue }">
      <div style="display: flex; flex-direction: column; gap: 12px;">
        <div class="sidebarHeader">
          <button
            type="button"
            class="toggleBtn"
            :class="{ active: modelValue }"
            @click="$emit('update:modelValue', !modelValue)"
            aria-label="Toggle sidebar"
          >
            <img class="toggleIcon" src="@/assets/icons/double-arrow-left.svg" alt="" />
          </button>

          <div class="brand" :class="{ active: modelValue }" aria-hidden="true">
            <img
              class="brandLogo"
              src="../assets/images/logo-perindo-new.png"
              alt="Partai Perindo"
            />
          </div>
        </div>

        <ul class="menu-list sidebarBody" :class="{ active: modelValue }">
          <li class="wrap">
            <router-link to="/dashboard" class="menu-wrap">
              <span class="icon" v-html="menuIcons.home"></span>
              <div class="text-small">Beranda</div>
            </router-link>
          </li>

          <li class="wrap">
            <router-link to="/dashboard/dokumen" class="menu-wrap">
              <span class="icon" v-html="menuIcons.document"></span>
              <div class="text-small">Dokumen Partai</div>
            </router-link>
          </li>

          <li class="wrap">
            <router-link to="/dashboard/agenda" class="menu-wrap">
              <span class="icon" v-html="menuIcons.agenda"></span>
              <div class="text-small">Agenda Perindo</div>
            </router-link>
          </li>

          <li class="wrap">
            <router-link to="/event-voucher" class="menu-wrap">
              <span class="icon" v-html="menuIcons.event"></span>
              <div class="text-small">Event Voucher</div>
            </router-link>
          </li>

          <li class="wrap">
            <router-link to="/dashboard/pemetaan-lokasi" class="menu-wrap">
              <span class="icon" v-html="menuIcons.rumah"></span>
              <div class="text-small">Rumah Perindo</div>
            </router-link>
          </li>

          <li class="wrap">
            <router-link to="/dashboard/profil" class="menu-wrap">
              <span class="icon" v-html="menuIcons.profile"></span>
              <div class="text-small">Profile</div>
            </router-link>
          </li>
        </ul>
      </div>

      <div class="menu-list sidebarFooter" :class="{ active: modelValue }">
        <div class="wrap" @click="$emit('logout')">
          <div class="menu-wrap">
              <span class="icon" v-html="menuIcons.logout"></span>
            <div class="text-small">Logout</div>
          </div>
        </div>
      </div>
    </div>
  </aside>
</template>

<script>
import { menuIcons } from '../assets/icons/menuIcons.js'

export default {
  name: 'SidebarDesktop',
  props: {
    modelValue: { type: Boolean, default: false }
  },
  data () {
    return {
      menuIcons
    }
  }
}
</script>

<style scoped>
.sidebar-desktop {
  flex: 0 0 auto;
}

.sidebarWrap {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background-color: #fff;
  border-radius: 10px;
  width: 80px;
  transition: width 0.35s ease;
  overflow: hidden;
}

@media only screen and (max-width: 600px) {
  .sidebarWrap {
    display: none;
  }
}

.sidebarWrap.active {
  width: 280px;
}

.sidebarHeader {
  position: relative;
  height: 92px;
  padding: 14px 14px 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 8px;
}

.brand {
  opacity: 0;
  transform: translateY(-4px);
  transition: opacity 0.25s ease, transform 0.25s ease;
  pointer-events: none;
}

.brand.active {
  opacity: 1;
  transform: translateY(0);
}

.brandLogo {
  height: 30px;
  width: auto;
  display: block;
}

.toggleBtn {
  position: absolute;
  left: 20px;
  top: 50%;
  transform: translateY(-50%);
  width: 36px;
  height: 36px;
  border-radius: 10px;
  border: 0;
  background: transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: left 0.35s ease, right 0.35s ease;
}

.toggleBtn.active {
  left: auto;
  right: 5px;
}

.toggleIcon {
  width: 20px;
  height: 20px;
  display: block;
  transition: transform 0.35s ease;
  transform: rotate(0deg);
}

.toggleBtn.active .toggleIcon {
  transform: rotate(180deg);
}

.sidebarBody {
  padding: 0 14px 14px;
}

.sidebarFooter {
  padding: 0 14px 14px;
}

.icon {
  margin-top: 6px;
  margin-left: 9px;
  width: 24px;
  height: 24px;
}

.menu-list {
  margin: 0;
  width: auto;
  padding: 12px;
}

.menu-list .wrap {
  list-style: none;
  width: 100%;
  margin-bottom: 10px;
}

.menu-list .wrap .menu-wrap {
  white-space: nowrap;
  border-radius: 7px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 6px;
  color: #667085;
}

.menu-list .wrap .menu-wrap.router-link-active.router-link-exact-active {
  background-color: #D6DFF4;
  color: #182773;
}

.menu-list .wrap .menu-wrap.router-link-active.router-link-exact-active .text-small {
  color: #243E81;
  font-weight: 600;
}

.menu-list .wrap .menu-wrap .text-small {
  display: inline-block;
  width: 0;
  overflow: hidden;
  font-size: 14px;
  color: black;
  transition: all 0.35s ease;
  vertical-align: sub;
  padding-left: 0;
  margin-left: 6px;
}

.menu-list .wrap .menu-wrap.main {
  background-color: transparent;
}

.menu-list.active .text-small {
  width: 150px !important;
  padding-left: 10px !important;
}

.menu-list.active .menu-wrap {
  justify-content: flex-start;
  padding-left: 12px;
}

.menu-list.active .icon {
  margin-left: 6px;
}
</style>
